<template>
  <div>
    {{ $t('message["1120"]') }}
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      company: {}
    }
  },
  computed: {
    ...mapState('team/invite', ['companyDatas']),
    invitecode () {
      return this.$route.query.invitecode || '7e2f02483bc38ac254e9ed146e178f0e'
    }
  },
  watch: {
    companyDatas (val) {
      if (!val) {
        return
      }
      this.company = val
    }
  },
  mounted () {
    const auth = this.$store.state.auth
    this.setAuth(auth)
    if (this.invitecode) {
      this.setInviteCode(this.invitecode)
    }
    // this.fetchCompanyDatas()
    this.fetchInviteIsVold()
  },
  methods: {
    ...mapActions('team/invite', ['fetchCompanyDatas', 'fetchInviteIsVold']),
    ...mapMutations('team/invite', ['setAuth', 'setInviteCode'])
  }
}
</script>
<style lang="scss" scoped>
</style>
